import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, ProductContextModel, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";
import translate from "@insite/client-framework/Translate";
import { Button, Checkbox, GridContainer, GridItem, LoadingSpinner } from "@insite/mobius/index";
import ProductPrice, { formatPriceToDisplay, formatPriceToDisplayforPIO } from "@NA/Overrides/Components/ProductPrice";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { ResolveThunks, connect, useSelector } from "react-redux";
import loadBundledProducts from "@NA/Handlers/ADILoadBundledProductsDataHandler";
import { ProductModel, RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import ADIProductDescription from "@NA/Components/ProductDetail/ADIProductDescription";
import { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import CustomAddToList from "@NA/Components/ProductDetail/CustomAddToList";
import FilterDown from "@NA/Icons/FilterDown";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import addCartLines from "@insite/client-framework/Store/Data/Carts/Handlers/AddCartLines";
import ADIColors from "@NA/Utils/ADIColors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import getColor from "@insite/mobius/utilities/getColor";
import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import ADIProductImage from "@NA/Components/BundledProducts/ADIProductImage";
import MiniMultipleProductModal from "../Cart/MiniMultipleProductModal";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { pushDataToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";
import { isProductInventoryOnlyRole } from "@NA/Widgets/MyAccount/ADIMyAccount";

const mapStateToProps = (state: CustomApplicationState) => {
    const isAuthenticated = state.context.session.isAuthenticated;
    const adiUserRoles = state.ADIGlobalData.ADIUserRoleStore;
    return {
        isAuthenticated,
        cart: getCurrentCartState(state).value,
        isCartLoading: getCurrentCartState(state).isLoading || state.ADIGlobalData.ADIUpdateCartLoading.loading,
        productSettings: getSettingsCollection(state).productSettings,
        showADIAddToCart: (adiUserRoles.fullAccess && adiUserRoles.accounting) || adiUserRoles.fullAccess,
        showADIAddToList: (adiUserRoles.fullAccess && adiUserRoles.accounting) || adiUserRoles.fullAccess,
        session: state.context.session,
        roles: state.context.session.userRoles,
        catalogSettings: state.context.settings.settingsCollection.catalogSettingSettings,
        currencySymbol: state.context.session.currency?.currencySymbol ?? "",
        addToCartLoading: state.context.isUpdatingCart,
    };
};

const mapDispatchToProps = {
    loadBundledProducts,
    addCartLines,
    loadCurrentCart,
};

type Props = WidgetProps &
    HasProduct &
    ADIProductInterface &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

export interface ADIPDPFrequentlyBoughtTogetherStyles {
    wrapper?: InjectableCss;
    heading?: TypographyPresentationProps;
    productImage?: ProductImageStyles;
    productGrid?: GridItemProps;
    mainProductGridContainer?: GridContainerProps;
    addToCartButton?: ButtonPresentationProps;
    mainAddToCartButtonGridItem?: GridItemProps;
    totalPrice?: TypographyPresentationProps;
    totalPriceGridItem?: GridItemProps;
    addTocartGridItem?: GridItemProps;
    addToListText?: TypographyProps;
    addToListTextGridItem?: GridItemProps;
    innerAddToCartButtonGridContainer?: GridContainerProps;
    productMainContainer?: GridContainerProps;
    firstSectionGrid?: GridItemProps;
    priceSectionGrid?: GridItemProps;
    priceSectionGridGrey?: GridItemProps;
    price?: ProductPriceStyles;
    mainSection?: InjectableCss;
    mainSectionGrey?: InjectableCss;
    productGridItems?: InjectableCss;
}

export const adiPDPFrequentlyBoughtTogethertyles: ADIPDPFrequentlyBoughtTogetherStyles = {
    mainSection: {
        css: css`
            display: flex;
            flex-direction: row;
        `,
    },
    mainSectionGrey: {
        css: css`
            display: flex;
            flex-direction: row;
            opacity: 0.5;
        `,
    },
    price: {
        price: {
            priceText: {
                css: css`
                    .priceText {
                        font-size: 20px;
                        color: #2d2926 !important;
                    }
                    .symbolText {
                        font-size: 12px;
                        position: relative;
                        top: 3px;
                        color: #2d2926 !important;
                        @media only screen and (max-width: 1024px) {
                            top: 1px;
                        }
                    }
                    .currencyText {
                        font-size: 12px;
                        color: #2d2926 !important;
                    }
                `,
            },
        },
    },
    firstSectionGrid: {
        css: css`
            img {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 52px !important;
                                object-fit: contain;
                            `,
                        ],
                        "max",
                    );
                }}
            }
            ,
            @media only screen and (max-width: 1024px) {
                padding-bottom: 0px;
            }
            > div[class^="sc"] {
                > ${StyledButton} {
                    padding-top: 21px;
                    @media only screen and (max-width: 1024px) {
                        padding-top: 0px;
                    }
                }
                > ${TypographyStyle} {
                    padding-top: 21px;
                    margin-left: 8px;
                    min-height: 78px;
                    height: 100%;
                    @media only screen and (max-width: 1024px) {
                        padding-top: 0px;
                        margin-left: 15px;
                        min-height: 60px;
                    }
                }
            }
        `,
    },
    priceSectionGrid: {
        css: css`
            > section[class^="sc"] {
                padding-left: 27px;
                @media only screen and (max-width: 1024px) {
                    padding-left: 20px;
                }
            }
        `,
    },
    priceSectionGridGrey: {
        css: css`
            > section[class^="sc"] {
                padding-left: 27px;
                opacity: 0.5;
                @media only screen and (max-width: 1024px) {
                    padding-left: 20px;
                }
            }
        `,
    },
    wrapper: {
        css: css`
            margin-bottom: 15px;
            @media only screen and (max-width: 1024px) {
                padding-left: 7px;
            }
        `,
    },
    heading: {
        css: css`
            min-height: 33px;
            font-size: 24px;
            font-weight: bold;
            padding-bottom: 20px;
            text-align: left;
            color: ${ADIColors.darkBlue1};
        `,
    },
    productImage: {
        img: {
            css: css`
                min-width: 52px;
                width: 64px;
                object-fit: contain;
                height: 52px;
            `,
        },
        linkWrappingImage: {
            css: css`
                width: auto;
            `,
        },
    },
    productGrid: {
        css: css`
            position: relative;
            border-right: solid 0.7px ${ADIColors.gray2};
            height: auto !important;
            min-height: 112px;
            &::after {
                position: absolute;
                color: ${ADIColors.blue5};
                float: right;
                display: flex;
                align-items: center;
                justify-content: center;
                top: calc(50% - 20px);
                font-size: 32px;
                right: -9px;
                width: 16px;
                background: ${ADIColors.white};
                height: 32px;
                border-radius: 8px;
                content: "+";
                padding: 8px 0;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            border-bottom: solid 0.7px ${ADIColors.gray2};
                            border-right: 0;
                            &::after {
                                position: absolute;
                                color: ${ADIColors.blue5};
                                float: right;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 32px;
                                background: ${ADIColors.white};
                                border-radius: 8px;
                                content: "+";
                                padding: 0 14px;
                                top: 92%;
                                right: 44%;
                                width: 20px;
                                height: 20px;
                            }
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    mainProductGridContainer: {
        css: css`
            margin-top: 30px;
            margin-bottom: 30px;
            > ${GridOffset} {
                > ${GridItemStyle} {
                    padding-left: 18px;
                }
            }
        `,
    },
    mainAddToCartButtonGridItem: {
        css: css`
            justify-content: center;
        `,
    },
    addToCartButton: {
        css: css`
            padding: 7px 7.2px;
            box-shadow: none;
            width: 67%;
            min-height: 33px;
            margin-bottom: 0;
            border-radius: 2.9px;
            background-color: ${ADIColors.blue5};
            margin-bottom: 8px;
            text-transform: none !important;
            font-size: 14px;
            font-weight: bold;
            @media only screen and (max-width: 1024px) {
                width: 100% !important;
                min-width: 323px !important;
            }
            @media only screen and (max-width: 767px) {
                min-width: 275px !important;
            }
        `,
    },
    totalPrice: {
        css: css`
            font-size: 29px;
            font-weight: 900;
            font-style: normal;
            text-align: left;
            color: ${getColor("text.main")};
            margin-left: 4px;
            margin-right: 1px;
            top: 2px;
            .priceText {
                font-size: 29px;
            }
            .symbolText {
                font-size: 18px;
                position: relative;
                top: 5px;
                @media only screen and (max-width: 1024px) {
                    top: 9px;
                }
                @media only screen and (max-width: 767px) {
                    top: 8px;
                }
            }
            .currencyText {
                font-size: 18px;
                position: relative;
                top: 4px;
                @media only screen and (max-width: 1024px) {
                    top: 6px;
                }
            }
        `,
    },
    totalPriceGridItem: {
        css: css`
            align-items: baseline;
            @media only screen and (max-width: 1024px) {
                align-items: center;
            }
            .totalPriceText {
                padding-top: 8px;
            }
            padding-bottom: 0;
            width: 100%;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            justify-content: center;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    addTocartGridItem: {
        css: css`
            padding-top: 5px;
            padding-bottom: 5px;
            width: 100%;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            justify-content: center;
                        `,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    innerAddToCartButtonGridContainer: {
        css: css`
            > ${GridOffset} {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
        `,
    },
    addToListText: {
        as: "span",
        css: css`
            color: ${ADIColors.darkBlue1};
            font-weight: 600;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            cursor: pointer;
            display: flex;
            align-items: center;
            svg {
                width: 13px;
                height: 7px;
                margin-left: 12px;
            }
            &:hover {
                text-decoration: underline;
            }
        `,
    },
    addToListTextGridItem: {
        css: css`
            position: relative;
            padding-top: 0;
            width: 100%;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    css`
                        justify-content: flex-start;
                    `,
                    css`
                        justify-content: flex-start;
                    `,
                    css`
                        justify-content: flex-start;
                    `,
                    null,
                ]);
            }}
        `,
    },
    productGridItems: {
        css: css`
            [data-test-selector="productPrice_Wrapper"] {
                [data-test-selector="productPrice_unitNetPrice"] {
                    color: #2d2926;
                    .symbolText {
                        color: #2d2926 !important;
                        position: relative;
                        top: -3px;
                        @media only screen and (max-width: 1024px) {
                            top: -4px;
                        }
                    }
                    .priceText {
                        color: #2d2926 !important;
                    }
                    .currencyText {
                        color: #2d2926 !important;
                        top: -5px;
                        position: relative;
                    }
                }
            }
        `,
    },
};

const styles = adiPDPFrequentlyBoughtTogethertyles;

interface ADIProductInterface {
    product: ProductContextModel;
    checkedProductIds: string[];
    changeCheckbox: (id: string) => void;
}

const ADIProduct = ({ product, checkedProductIds, changeCheckbox }: ADIProductInterface) => {
    const [isChecked, setIsChecked] = React.useState(false);
    const isPendingVerification = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isPendingVerification,
    );
    React.useEffect(() => {
        const checked = checkedProductIds.includes(product.product.id);

        setIsChecked(checked);
    }, [checkedProductIds]);

    return (
        <GridContainer {...styles.productMainContainer}>
            <GridItem width={12} {...styles.firstSectionGrid}>
                <Checkbox checked={isChecked} onChange={() => changeCheckbox(product.product.id)} />
                <StyledWrapper {...(isChecked ? styles.mainSection : styles.mainSectionGrey)}>
                    <ADIProductImage
                        product={product}
                        sourceName="Frequently Bought Together"
                        extendedStyles={styles.productImage}
                    />
                    <ADIProductDescription product={product.product} />
                </StyledWrapper>
            </GridItem>
            <GridItem width={12} {...(isChecked ? styles.priceSectionGrid : styles.priceSectionGridGrey)}>
                <ProductPrice product={product} showSavings={false} showLabel={false} extendedStyles={styles.price} />
            </GridItem>
        </GridContainer>
    );
};

const ADIPDPFrequentlyBoughtTogether: React.FC<Props> = ({
    product,
    productInfo,
    loadBundledProducts,
    isAuthenticated,
    addCartLines,
    cart,
    showADIAddToCart,
    showADIAddToList,
    loadCurrentCart,
    productSettings,
    session,
    roles,
    catalogSettings,
    currencySymbol,
    addToCartLoading,
    isCartLoading,
}) => {
    const productContext = { product, productInfo };
    const [bundleProducts, setBundleProducts] = React.useState<ProductModel[]>([]);
    const [bundleProductsInfo, setBundleProductsInfo] = React.useState<Record<string, ProductInfo>>();
    const [checkedProductIds, setCheckedProductIds] = React.useState<string[]>([]);
    const [productTotal, setProductTotal] = React.useState(0);
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [isAddToCartLoading, setIsAddToCartLoading] = React.useState<boolean>(false);
    const [selectedProductinfo, setSelectedProductinfo] = React.useState<ProductInfo[]>([]);
    const [isMiniCartModalOpen, setIsMiniCartModalOpen] = React.useState(false);
    const [tracked, setTracked] = React.useState(false);
    const isProcessingRef = React.useRef(false);
    const isPendingVerification = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isPendingVerification,
    );
    const openMiniCartHandler = () => {
        setIsAddToCartLoading(true);
        loadCurrentCart({
            shouldLoadFullCart: false,
            replaceCart: false,
            onSuccess() {
                setIsAddToCartLoading(false);
                setIsMiniCartModalOpen(true);
            },
        });
    };

    const closeMiniCartHandler = () => {
        setIsMiniCartModalOpen(false);
    };

    const addToListOpen = () => {
        setIsOpen(prev => !prev);
    };

    React.useEffect(() => {
        if (
            !productInfo.pricing ||
            !product.properties.bundleProductErpNumber ||
            product.properties.bundleProductErpNumber === ""
        ) {
            return;
        }

        const bundleProductErpNumber = product.properties.bundleProductErpNumber.split(",");
        let totalProductAmount = productInfo.pricing?.unitNetPrice ? productInfo.pricing?.unitNetPrice : 0;
        let checkedItems: string[] = [];
        checkedItems.push(product.id);

        loadBundledProducts({
            productNumbers: bundleProductErpNumber,
            expand: "properties",
            onSuccess(result: any) {
                const productInfosByProductIdKey = Object.keys(result.productInfosByProductId);

                if (productInfosByProductIdKey) {
                    productInfosByProductIdKey.forEach(item => {
                        const price = result.productInfosByProductId[item].pricing?.unitNetPrice;
                        if (price) {
                            totalProductAmount += price;
                        }
                        checkedItems.push(item);
                    });
                }
                setBundleProducts(result.products);
                setBundleProductsInfo(result.productInfosByProductId);
                setProductTotal(totalProductAmount);
                setCheckedProductIds(checkedItems);
            },
        });
    }, [productInfo.pricing, product.properties.bundleProductErpNumber]);

    React.useEffect(() => {
        let newProductInfos: ProductInfo[] = [];
        if (bundleProductsInfo) {
            const bundleProductsInfokeys = Object.keys(bundleProductsInfo);
            checkedProductIds.forEach(id => {
                if (bundleProductsInfokeys.includes(id)) {
                    newProductInfos.push(bundleProductsInfo[id]);
                }
                if (product.id === id) {
                    newProductInfos.push(productInfo);
                }
            });

            setSelectedProductinfo(newProductInfos);
        }
    }, [checkedProductIds]);

    React.useEffect(() => {
        let newProduct: ProductModel[] = [];
        let newProductInfos: ProductInfo[] = [];
        if (bundleProductsInfo) {
            const bundleProductsInfokeys = Object.keys(bundleProductsInfo);
            checkedProductIds.forEach(id => {
                if (bundleProductsInfokeys.includes(id)) {
                    let prod: ProductModel[] = [];
                    newProductInfos.push(bundleProductsInfo[id]);
                    prod = bundleProducts.filter(item => item.id == id);
                    if (prod.length == 1) newProduct.push(prod[0]);
                }
                if (product.id === id) {
                    newProductInfos.push(productInfo);
                    newProduct.push(product);
                }
            });
        }
        if (newProductInfos && newProduct && newProduct.length > 0 && !tracked) {
            sendForTracking(newProduct, newProductInfos);
        }
    }, [checkedProductIds]);

    if (!isAuthenticated) {
        return null;
    }

    function sendForTracking(products: ProductModel[], productInfos: ProductInfo[]) {
        if (session.isAuthenticated && !productInfos[0]?.failedToLoadPricing && productInfos[0]?.pricing) {
            let realtimePricing: RealTimePricingModel = {
                realTimePricingResults: [],
                uri: "",
                properties: {},
            };
            products.forEach((prod, productIndex) => {
                const price = productInfos[productIndex]?.pricing;
                if (price) {
                    realtimePricing.realTimePricingResults?.push(price);
                }
            });
            pushDataToDataLayer(products, "Frequently Bought Together", session, realtimePricing);
            setTracked(true);
        }
    }

    const changeCheckbox = (id: string) => {
        let checkedproducts: string[] = [];
        if (checkedProductIds.includes(id)) {
            let total = productTotal;
            checkedproducts = checkedProductIds.filter(item => item !== id);

            if (bundleProductsInfo && bundleProductsInfo[id]) {
                const price = bundleProductsInfo[id].pricing?.unitNetPrice;
                if (price) {
                    total -= price;
                }
            }

            if (product.id === id) {
                const price = productInfo.pricing?.unitNetPrice ? productInfo.pricing?.unitNetPrice : 0;
                total -= price;
            }
            setProductTotal(total);
            setCheckedProductIds(checkedproducts);
        } else {
            let total = productTotal;
            if (bundleProductsInfo && bundleProductsInfo[id]) {
                const price = bundleProductsInfo[id].pricing?.unitNetPrice;
                if (price) {
                    total += price;
                }
            }
            if (product.id === id) {
                const price = productInfo.pricing?.unitNetPrice ? productInfo.pricing?.unitNetPrice : 0;
                total += price;
            }
            setProductTotal(total);
            setCheckedProductIds([...checkedProductIds, id]);
        }
    };

    if (product.properties && product.properties.bundleProductErpNumber == "") {
        return null;
    }

    const onAddtoCartHandler = () => {
        if (isProcessingRef.current) {
            return; // Prevent multiple clicks
        }
        isProcessingRef.current = true;
        sessionStorage.setItem("item_list_name", "Frequently Bought Together");
        let newProductInfos: ProductInfo[] = [];
        if (!isAddToCartLoading && isProcessingRef.current) {
            setIsAddToCartLoading(true);
            if (bundleProductsInfo) {
                const bundleProductsInfokeys = Object.keys(bundleProductsInfo);
                checkedProductIds.forEach(id => {
                    if (bundleProductsInfokeys.includes(id)) {
                        newProductInfos.push(bundleProductsInfo[id]);
                    }
                    if (product.id === id) {
                        newProductInfos.push(productInfo);
                    }
                });
            }

            addCartLines({
                productInfos: newProductInfos,
                onComplete() {
                    setIsAddToCartLoading(false);
                    isProcessingRef.current = false;
                    if (productSettings.showAddToCartConfirmationDialog) {
                        openMiniCartHandler();
                    }
                },
            });
        }
    };

    if (bundleProducts.length === 0) {
        return null;
    }

    return (
        <>
            {bundleProducts && (
                <StyledWrapper {...styles.wrapper}>
                    <Typography {...styles.heading}>{translate("Frequently Bought Together")}</Typography>
                    <GridContainer {...styles.mainProductGridContainer}>
                        <GridItem width={12}>
                            <GridContainer>
                                <GridItem width={[12, 12, 12, 12, 3]} {...styles.productGrid}>
                                    <ADIProduct
                                        product={productContext}
                                        checkedProductIds={checkedProductIds}
                                        changeCheckbox={changeCheckbox}
                                        {...styles.productGridItems}
                                    />
                                </GridItem>
                                {bundleProducts.map((item, index) => (
                                    <React.Fragment key={item.id}>
                                        {bundleProductsInfo &&
                                            (bundleProducts.length - 1 === index ? (
                                                <GridItem width={[12, 12, 12, 12, 3]}>
                                                    <ADIProduct
                                                        product={{
                                                            product: item,
                                                            productInfo: bundleProductsInfo[item.id],
                                                        }}
                                                        checkedProductIds={checkedProductIds}
                                                        changeCheckbox={changeCheckbox}
                                                        {...styles.productGridItems}
                                                    />
                                                </GridItem>
                                            ) : (
                                                <GridItem width={[12, 12, 12, 12, 3]} {...styles.productGrid}>
                                                    <ADIProduct
                                                        product={{
                                                            product: item,
                                                            productInfo: bundleProductsInfo[item.id],
                                                        }}
                                                        checkedProductIds={checkedProductIds}
                                                        changeCheckbox={changeCheckbox}
                                                        {...styles.productGridItems}
                                                    />
                                                </GridItem>
                                            ))}
                                    </React.Fragment>
                                ))}
                                {checkedProductIds.length > 0 && productTotal > 0 && !isPendingVerification && (
                                    <GridItem width={[12, 12, 12, 12, 3]} {...styles.mainAddToCartButtonGridItem}>
                                        <GridContainer {...styles.innerAddToCartButtonGridContainer}>
                                            <GridItem width={[12, 6, 6, 6, 12]} {...styles.totalPriceGridItem}>
                                                <Typography className="totalPriceText">
                                                    {translate("Total Price:")}
                                                </Typography>
                                                <Typography {...styles.totalPrice}>
                                                    {!isProductInventoryOnlyRole(roles)
                                                        ? formatPriceToDisplay(productTotal)
                                                        : formatPriceToDisplayforPIO(catalogSettings, currencySymbol)}
                                                </Typography>
                                            </GridItem>
                                            <GridItem width={[12, 6, 6, 6, 12]} {...styles.addTocartGridItem}>
                                                {showADIAddToCart && !isPendingVerification ? (
                                                    <Button {...styles.addToCartButton} onClick={onAddtoCartHandler}>
                                                        {isAddToCartLoading && (
                                                            <LoadingSpinner
                                                                size={12}
                                                                color={ADIColors.white}
                                                                style={{ marginRight: 15 }}
                                                            />
                                                        )}

                                                        {translate("Add to Cart")}
                                                    </Button>
                                                ) : null}
                                            </GridItem>
                                            {showADIAddToList && !isPendingVerification && (
                                                <GridItem width={[12, 6, 6, 6, 12]} {...styles.addToListTextGridItem}>
                                                    <Typography {...styles.addToListText} onClick={addToListOpen}>
                                                        {translate("Add To List")}
                                                        <FilterDown />
                                                    </Typography>
                                                    <CustomAddToList
                                                        isOpen={isOpen}
                                                        setIsOpen={setIsOpen}
                                                        productInfos={productInfo}
                                                    />
                                                </GridItem>
                                            )}
                                        </GridContainer>
                                    </GridItem>
                                )}
                            </GridContainer>
                            {cart?.cartLines && cart.cartLines.length > 0 && (
                                <MiniMultipleProductModal
                                    isModalOpen={isMiniCartModalOpen}
                                    onModalClose={closeMiniCartHandler}
                                    cartLines={cart.cartLines}
                                    productIdArray={checkedProductIds}
                                />
                            )}
                        </GridItem>
                    </GridContainer>
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withProduct(ADIPDPFrequentlyBoughtTogether)),
    definition: {
        displayName: "ADI PDP Frequently Bought Together",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
